import * as constants from './constants';
import { ISecLevel } from './interfaces';
import { ActionTypes } from './actions';

const { SET_SEC_LEVEL, RESET_SEC_LEVEL } = constants;

const initialState: ISecLevel = {
  secLevel: 0,
};

const secLevel = (
  state = Object.assign({}, initialState),
  action: ActionTypes,
): ISecLevel => {
  switch (action.type) {
    case SET_SEC_LEVEL:
      return { secLevel: action.payload };
    case RESET_SEC_LEVEL:
      return { ...Object.assign({}, initialState) };
    default:
      return state;
  }
};
export default secLevel;
